// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "flickity" + "." + "a7dab41825bb421785d2" + ".js";
};